import { baseResponseSchema } from 'services/api/api.types';
import { z } from 'zod/v4';
/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

const sessionLossDetailResponseSchema = baseResponseSchema.extend({
  responseObject: z.object({
    sessionToken: z.string(),
    accountCode: z.string(),
    // loss: z.object({
    //   lossCounter: z.number(),
    //   availableLoss: z.number(),
    //   lossLimit: z.number(),
    // }),
    time: z.object({
      // startSessionTime: z.number(),
      endSessionTime: z.number(),
      // elapsedTime: z.number(),
      // availableTime: z.number(),
      // timeLimit: z.number(),
    }),
    // coolOff: z.object({
    //   cooloffStatus: z.boolean(),
    //   remainingTime: z.number(),
    //   nextAvailableStartSessionTimestamp: z.number(),
    // }),
  }),
});

type SessionLossDetailIResponse = z.infer<
  typeof sessionLossDetailResponseSchema
>;

type TransformedSessionLossDetailResponse = ReturnType<
  typeof transformSessionLossDetailResponse
>;

/*-------------------------------------------------------------------------------------------------
 * transformer helper
 * -----------------------------------------------------------------------------------------------*/

const transformSessionLossDetailResponse = (
  response: SessionLossDetailIResponse,
) => {
  const { responseObject } = response;

  const endSessionTime = responseObject?.time?.endSessionTime; // fine ultima sessione
  const currentTimestamp = Math.floor(Date.now() / 1000);

  const has60MinutesPassedSinceEndSession = endSessionTime
    ? currentTimestamp - endSessionTime >= 3600
    : true; // non dovrebbe mai succede ma lo consideriamo come un errore del servizio quindi non facciamo vedere il banner

  return {
    ...responseObject,
    has60MinutesPassedSinceEndSession,
  };
};

export { sessionLossDetailResponseSchema, transformSessionLossDetailResponse };
export type {
  SessionLossDetailIResponse,
  TransformedSessionLossDetailResponse,
};
